<template>
  <router-view/>
</template>
<script>
import pkg from "../package.json";
export default {
  name: 'App',
  data() {
    return {
      appModule: pkg.dependencies["@moeinmdn/mixitweb-front-modules"],
      appVersion: pkg.dependencies["@moeinmdn/miw-alpha-components"],
      appRouter: pkg.dependencies["@moeinmdn/miw-router"],
    }
  },
  mounted() {

    let checker = document.querySelector('#version-item');

    let txt = `
M ${this.appModule} -
C ${this.appVersion} -
R ${this.appRouter}
`;

    let finalHtml = `
  <a class="text-decoration-none d-print-none"
     href="https://mixitweb.com/release-note"
     target="_blank">
     ${txt}
  </a>
`;

    if (!checker) {
      // ساختن المنت جدید
      const versionEl = document.createElement('div');
      versionEl.id = 'version-item';

      // استایل‌ها
      versionEl.style.color = '#000';
      versionEl.style.padding = '6px 12px';
      versionEl.style.fontSize = '12px';
      versionEl.style.textAlign = 'center';
      versionEl.style.direction = 'ltr';

      // مقدار نسخه
      versionEl.innerHTML = finalHtml;

      // افزودن به body
      document.body.appendChild(versionEl);

    } else {
      // اگر وجود داشت فقط مقدار را آپدیت کن
      checker.innerHTML = finalHtml;
    }
  }
}
</script>
